module.exports = __webpack_public_path__ + "images/般蓝pr长图_05.jpg?v=e3bd3a29";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图_05.jpg
 ** module id = 182
 ** module chunks = 1 2
 **/